import { render } from "./publicUrlsForm.vue?vue&type=template&id=45330ff1&scoped=true"
import script from "./publicUrlsForm.vue?vue&type=script&lang=js"
export * from "./publicUrlsForm.vue?vue&type=script&lang=js"

import "./publicUrlsForm.vue?vue&type=style&index=0&id=45330ff1&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45330ff1"]])

export default __exports__